import $$ from "cmn-utils";

const baseUrl = "/api/enterprise/alarm/";
export default {
  list: (params) => {
    return $$.get(baseUrl + "list", params);
  },
  get: (params) => {
    return $$.get(baseUrl + "get", params);
  },
};
